import { DocumentFile } from '@models/document-file';
import { SPREAD_ORIGIN_CHOICES } from '@utils/constants';

const VENDOR_DATA_LABEL_PREFIX = 'S&P';

export function isVendorDataSpread(documentFile: Pick<DocumentFile, 'spreadOrigin'> | null | undefined): boolean {
  return documentFile?.spreadOrigin === SPREAD_ORIGIN_CHOICES.BATCH_SOURCE_S_AND_P_FEED;
}

/**
 * Identifier shown in place of a document name for vendor data, e.g. "S&P 10/31/2022 Original".
 * Statement date arrives as an ISO date string (YYYY-MM-DD).
 */
export function getVendorDataLabel(documentFile: Pick<DocumentFile, 'statementDate' | 'classification'>): string {
  const parts = [VENDOR_DATA_LABEL_PREFIX, formatStatementDate(documentFile.statementDate), documentFile.classification];
  return parts.filter(part => !!part).join(' ');
}

function formatStatementDate(isoDate: string | null | undefined): string {
  if (!isoDate) {
    return '';
  }
  const [year, month, day] = isoDate.substring(0, 10).split('-');
  return `${month}/${day}/${year}`;
}
